import React from "react";
import { getSampleProposals } from "./services/proposalsService";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";

export default function ProposalsDashboard() {
  const proposals = getSampleProposals();

  const getStatusVariant = (status) => {
    switch (status.toLowerCase()) {
      case "awarded":
        return "success";
      case "submitted":
        return "default";
      case "draft":
        return "secondary";
      default:
        return "outline";
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Proposals</h1>
        <p className="text-muted-foreground">
          Track and manage your proposals
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Proposal List</CardTitle>
          <CardDescription>
            {proposals.length} proposals found
          </CardDescription>
        </CardHeader>
        <CardContent>
          {proposals.length === 0 ? (
            <p className="text-muted-foreground text-center py-8">
              No proposals yet - coming soon.
            </p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>ID</TableHead>
                  <TableHead>Opportunity</TableHead>
                  <TableHead>Status</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {proposals.map((p) => (
                  <TableRow key={p.id}>
                    <TableCell className="font-medium">{p.id}</TableCell>
                    <TableCell>{p.opportunity}</TableCell>
                    <TableCell>
                      <Badge variant={getStatusVariant(p.status)}>
                        {p.status}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
